import { render, staticRenderFns } from "./ZeroBalanceForm.vue?vue&type=template&id=5154361f&scoped=true&"
import script from "./ZeroBalanceForm.vue?vue&type=script&lang=ts&"
export * from "./ZeroBalanceForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5154361f",
  null
  
)

export default component.exports